import Repository from '@/repositories/marketing'
const resource = '/preference_pages'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    /**
     * Used In : Footer -> Preview preference pages content
     * @param {Number | String} pageId // use case under ANC-1702
     * @param {Object} config
     */
    preview (pageId, config) {
        return Repository.get(`${resource}/preview/${pageId}.json`, config)
    },
    create(config){
        return Repository.post(`${resource}.json`,config)
    },
    fetchById(id,config){
        return Repository.get(`${resource}/${id}.json`,config)
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}.json`, data)
    },
    validateName(config){
        return Repository.get(`${resource}/validate_name.json`,config)
    },
    getPageType(config){
        return Repository.get(`${resource}/get_page_types_list.json`,config)
    },
    getHtmlJsonPart(config){
        return Repository.get(`${resource}/fetch_default_html_or_json_part.json`,config)
    },
    
}
